import styled from 'styled-components';
import ArticleCard from './ArticleCard';

const Container = styled.div`
  width: 100%;
  height: auto;
  background-color: #0864bb;
`;

const ArticleGrid = ({ articles }) => {
  return (
    <Container>
      {articles.map((article) => {
        return <ArticleCard props={article} />;
      })}
    </Container>
  );
};

export default ArticleGrid;
